export default __webpack_public_path__ + "static/media/Vivek Ramaswamy.1a06477a.jpg";